import usePractices from "../../../hooks/usePractices";
import { TemplateWrapped } from "../../Layout";
import { getTheme } from "../../../constants/getTheme";
import { ConnectionsMainContent } from "../../pages/ConnectionsDiva/components";
import React from "react";

const withSelectedPractices = (Component) => (props) => {
  const { selectedPractices } = usePractices();

  return selectedPractices.length > 0 ? (
    <Component selectedPractices={selectedPractices} {...props} />
  ) : (
    <ShowConnections />
  );
};

const ShowConnections = () => {
  const theme = getTheme(process.env.REACT_APP_CLIENT_THEME);
  return (
    <TemplateWrapped showTitle={false}>
      <main className="flex-1 p-6 mt-5">
        <div
          className="alert alert-alt alert-warning"
          role="alert"
          style={{
            padding: "20px 12px",
            fontSize: "14px",
            borderLeft: "3px solid",
          }}
        >
          Dear user, once you select a connection, the corresponding data will
          be displayed
        </div>
        <ConnectionsMainContent />
      </main>
    </TemplateWrapped>
  );
};

export default withSelectedPractices;
